import get from 'lodash/get';
import { PageTemplateProps } from 'types/pages';
import { Footer } from 'components/organisms/Footer';
import Header from 'components/organisms/Header/Header';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import { LinkSourceDomain } from 'components/molecules/LinkSourceDomain';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';
import TemplateWrapper from './partials/TemplateWrapper';
import ComponentsRenderer from './partials/ComponentsRenderer';

const BlogTemplate: React.FC<PageTemplateProps> = ({ data, header, footer }) => {
  const { alternate_languages } = data;

  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <PageBackground />
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <ComponentsRenderer slices={get(data, 'data.body1', [])} />
      <LinkSourceDomain pageData={data.data} />
      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

export default BlogTemplate;
